import { ProductWS } from '@/types/prestashop';
import { ProductBase, ProductDetail } from '@/types/product';

/**
 * Mapea un ProductWS a Product
 */
export async function mapProductWSToProductBase(
  product: ProductWS,
  index: number
): Promise<ProductBase> {
  // Obtener imagen real de PrestaShop
  let productImage = '/images/img_pasta_mista_6_copia_2.png'; // Fallback

  return {} as ProductBase;
}

/**
 * Mapea un array de ProductWS a Product[]
 */
export async function mapProductsWSToProducts(products: ProductWS[]): Promise<ProductBase[]> {
  const mappedProducts = await Promise.all(
    products.map((product, index) => mapProductWSToProductBase(product, index))
  );
  return mappedProducts;
}

export function generateColor(index: number): string {
  const colors = ['#ADDAD3', '#FFADAD', '#EE9E35', '#CFB1FF', '#FFDE3B', '#BFBF75', '#E15E30'];
  return colors[index % colors.length];
}

export async function mapProductWSToProductDetail(product: ProductWS): Promise<ProductDetail> {
  // Obtener imagen real de PrestaShop
  let productImage = '/images/img_pasta_mista_6_copia_2.png'; // Fallback

  return {} as ProductDetail;
}
